import { useQuery } from 'react-query';
import { verifyExternalToken } from '../apis/auth';
export const useVerifyExternalToken = (token: string) => {
	return useQuery({
		queryKey: ['getCourse', token],
		queryFn: async () => (await verifyExternalToken({ token })).data as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!token,
	});
};
